const prefix = dbclnr_database_cleaner.prefix;
const dbPrefix = dbclnr_database_cleaner.db_prefix;
const domain = dbclnr_database_cleaner.domain;
const restUrl = dbclnr_database_cleaner.rest_url.replace(/\/+$/, "");
const apiUrl = dbclnr_database_cleaner.api_url.replace(/\/+$/, "");
const pluginUrl = dbclnr_database_cleaner.plugin_url.replace(/\/+$/, "");
const isPro = dbclnr_database_cleaner.is_pro === '1';
const isRegistered = isPro && dbclnr_database_cleaner.is_registered === '1';
const restNonce = dbclnr_database_cleaner.rest_nonce;
const core = dbclnr_database_cleaner.core;
const coreCount = dbclnr_database_cleaner.core_count;
const options = dbclnr_database_cleaner.options;

// Generate 2 options by using the option "db_historical_sizes".
const totalSizes = options.db_historical_sizes;
const totalSize = totalSizes ? totalSizes[totalSizes.length - 1] : null;
let previousTotalSize = null
if (totalSizes?.length > 1) {
    previousTotalSize = totalSizes[totalSizes.length - 2];
} else if (totalSizes?.length > 0) {
    previousTotalSize = totalSizes[totalSizes.length - 1];
}
options.totalSize = totalSize;
options.previousTotalSize = previousTotalSize;

export { prefix, dbPrefix, domain, apiUrl, restUrl, pluginUrl, isPro, isRegistered, restNonce, core, coreCount, options };
